export default {"src":"/_next/static/media/search.9cd84f59.svg","height":36,"width":36};